import { LoadableAfterPaint } from '@confluence/loadable';
import { RendererPageCoverPicturePlaceholder } from '../src/RendererCoverPicture/RendererPageCoverPicturePlaceholder.tsx';

export const RendererPageCoverPicture = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-RendererCoverPictureRendererPageCoverPicture" */ '../src/RendererCoverPicture/RendererPageCoverPicture.tsx'
			)
		).RendererPageCoverPicture;
	},
	loading: RendererPageCoverPicturePlaceholder,
});
